import React from 'react'
import moment from 'moment'

import {
  BrowserRouter as Router,
  Route,
  Link,
  Switch
} from 'react-router-dom'
import { push, goBack } from 'react-router-redux'
import './Trips.css'
import Card from '../core/Card'
import SideNav from '../layout/SideNav'
import { Icon, TripsIcon, PaperclipIcon, NoteIcon, BackIcon, BriefcaseIcon, CarIcon, DotIcon, ForwardIcon, MergeIcon } from '../core/icons'
import { Row, Col, Button, Select, DatePicker, Icon as AIcon, Tag, Tooltip, Popover, Checkbox, Dropdown } from 'antd';
import { connect } from 'react-redux'
import { toggleTrip, loadMore, getTrips, updateRange, selectFilter, clearFilters, selectPlaceFilter, updateTrip } from './actions'
import Summary from './Summary'
import { withPreviousDate, getPurposes } from './reducer'
import Line from '../core/Line'
import numeral from 'numeral';
import styled from 'styled-components'

const { MonthPicker, RangePicker } = DatePicker;
const { Option } = Select

const Hover = ({ onHover, children }) => (
    <div className="hover">
        <div className="hover__no-hover">{children}</div>
        <div className="hover__hover">{onHover}</div>
    </div>
)

const mapStateToProps = ({trips, account, models}, ownProps)=>({
  ...ownProps.trip,
  isChecked: trips.filter_params.token_ids.includes(ownProps.trip.token_id),
  isAnyTripChecked: trips.filter_params.token_ids.length > 0,
  checkboxesVisible: trips.checkboxesVisible,
  purposes: getPurposes({models}),
  kms_enabled: models.user.kms_enabled,
})

const mapDispatchToProps = (dispatch) => {
  return {
    toggleTrip: (token_id)=>dispatch(toggleTrip(token_id)),
    updateTrip: (token_id, value)=>dispatch(updateTrip(token_id, value)),
    onClickTripLine: (token_id) => dispatch(push(`/trips/${token_id}`))
  }
}

const iconType = (purpose, income_source) => {
  if (purpose == null) {
    return "Unclassified"
  }
  return income_source || purpose
}

const Deduction = styled.div`
  color: rgb(49, 181, 159);
  opacity: 0.8;
  font-size: 24px!important;
  font-weight: 600;
  ${props=>props.isZero&&`
    display: none;
  `}
  ${props=>props.isUnclassified&&`
    color: rgb(150, 162, 194);
    // text-decoration: underline;
    font-weight: 100;
  `}
`
const DateBreak = styled.h1`
  background: #edf2f5;
  margin: -2.1vw -2vw 3vw -2vw;
  padding: 0.2vw 2vw;
  text-transform: none;
  font-weight: 500;
  font-size: 18px;
  // height: 40px;
`

// TODO handle locations (array), auto_detected (bool), started_at, started_at_coordinate, income_source, start_place
const TripLine = connect( mapStateToProps, mapDispatchToProps)(
  ({ checkboxesVisible, parent_trip, notes, photo, start_place, end_place, updateTrip,
    purposes, places, isChecked, isAnyTripChecked, income_source, toggleTrip,
    started_at, ended_at, prevTrip, isSameDate, token_id, vehicle_id, miles, kms,
    kms_enabled, purpose, from, to, savings, locations, date_formatted, onClickTripLine,
    favorite_trip, deduction, style, key
  }) =>
  <div className="TripLine" style={style} key={key}>

    {isSameDate? <hr/> : <DateBreak>{moment(date_formatted).format("dddd, MMMM Do YYYY")}</DateBreak>}
    <Line className="Line" >
      <Col className={"purpose " + purpose} xs={20} sm={8} xl={4}>
          <Hover onHover={
              <Checkbox className="checkbox-large" onChange={()=>toggleTrip(token_id)} checked={isChecked} />
          }>
              {
                ((checkboxesVisible))
                ? <Checkbox className="checkbox-large" onChange={()=>toggleTrip(token_id)} checked={isChecked} />
                : <Icon type={iconType(purpose, income_source)} selected/>
              }
          </Hover>
          <div className={"purpose-label " + (income_source || purpose || 'Unclassified')}>
            <Select
              onChange={(value)=>updateTrip({token_id: token_id, purpose: value})}
              value={income_source || purpose || 'Unclassified'}
            >
              {purposes.map((p,i)=> <option key={i} value={p}>{p}</option> )}
            </Select>
          </div>
      </Col>

      <Col xs={4} sm={2} md={2} lg={2}>
        <Row justify="center" type="flex">
          <Deduction isZero={deduction==0} isUnclassified={!purpose}>${-deduction}</Deduction>
        </Row>
      </Col>

      <Col className="fromto" xs={24} md={9} onClick={()=> onClickTripLine(token_id)}>
        <Row className={"title" + (start_place ? " favorite-place":"")}>
          <DotIcon color='#31B59F'/>
          { start_place ? start_place.name : from }
        </Row>
        <Row className={"title" + (end_place ? " favorite-place":"")}>
          <DotIcon color='#FF5166'/>
          { end_place ? end_place.name : to }
        </Row>

      </Col>

      <Col xs={23} sm={3} md={2} onClick={()=> onClickTripLine(token_id)}>
        <div className="miles" style={{textAlign: 'center'}}>{numeral(kms_enabled?kms:miles).format('(0,0.0)')} {kms_enabled?'km':'mi'}</div>
        {(notes || photo || favorite_trip || parent_trip) &&
          <Row type='flex' justify="space-around" align="middle" style={{padding: "10px 30px 0"}}>
            {notes && <Tooltip title={notes}><span><NoteIcon/></span></Tooltip>}
            {photo && <Tooltip title={<img width="100" src={photo.image_url}></img>}><span><PaperclipIcon/></span></Tooltip>}
            { (favorite_trip) &&
              <Tooltip title={"Favorite Trip Detected"}>
                <span><TripsIcon/></span>
              </Tooltip>
            }
            {parent_trip && <Tooltip title={'Trip was merged. Click to view and/or undo merge.'}><span><MergeIcon/></span></Tooltip>}
          </Row>
        }
      </Col>
      <Col xs={0} sm={1} onClick={()=> onClickTripLine(token_id)}>
        <AIcon type="right" style={{fontSize: "27px", color: "#95a2c2"}} />
      </Col>
    </Line>

  </div>
)

export default TripLine



// WEBPACK FOOTER //
// ./src/trips/TripLine.js